var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.38 72.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e3007e;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Street_Right",
    "data-name": "Street Right"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.19,
    cy: 36.19,
    r: 36.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.19 9.79 42.49 29.19 62.9 29.19 46.39 41.19 52.7 60.59 36.19 48.6 19.68 60.59 25.99 41.19 9.48 29.19 29.89 29.19 36.19 9.79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/news_icon.55fafb42ea861454d195498d5ad4715f.svg";
export { ForwardRef as ReactComponent };